// @owners { team: patients }
import { createSelector } from 'reselect';
import getShipments from './getShipments';
import { type ReduxStateShared } from '~shared/types';

export const getIsShipmentIDKnownInClientState = createSelector(
  [getShipments, (_: ReduxStateShared, shipmentID: number | undefined) => shipmentID],
  (shipments, shipmentID): boolean => {
    if (!shipmentID && shipmentID !== 0) return true;
    return shipments.some((s) => s.id === shipmentID);
  },
);
